<template>
  <td>
    <!-- <button class="k-primary k-button k-grid-edit-command" @click="editHandler">Edit</button>
    <button class="k-button k-grid-remove-command" @click="removeHandler">Remove</button> -->

    <span class="action-icon nt-edit mx-2 k-link" @click="editHandler"></span>
    <span class="action-icon nt-trash-fill k-link" @click="confirmDelete"></span>
    <span
      type="button"
      class=" mx-2 action-icon k-link"
      @click="auditHandler"
      v-b-toggle.sidebar-right
    >
      <span class="nt-clock"></span>
    </span>
    <DialogBox
    ref="removeTenantDtl"
    @OkMethod="OkMethod"
    @closed="closeDialog"
    ></DialogBox>
  </td>
</template>
 
<script>
import DialogBox from "@/components/DialogBox.vue";
export default {
  props: {
    dataItem: Object,
    columnIndex: Number
  },
  components:{
    DialogBox
  },
  watch: {
    dataItem: function(newVal) {
      this.item = newVal;
    }
  },
  methods: {
    confirmDelete() {
      this.$refs.removeTenantDtl.openWindow();
    },
    OkMethod() {
      this.removeHandler();
    },
    closeDialog() {
      this.$refs.removeTenantDtl.closeWindow();
    },
    editHandler: function() {
      this.$emit("edit", { dataItem: this.item });
    },
    removeHandler: function() {
      this.$emit("remove", { dataItem: this.item });
    },
    auditHandler: function() {
      this.$emit("audit", { dataItem: this.item });
      
    },
  },
  data: function() {
    return {
      item: { ...this.dataItem }
    };
  }
};
</script>
 
<style>
</style>
